module.exports = __webpack_public_path__ + "img/icon-install.f30ce554.svg";